import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './i18n/LanguageContext';
import Home from './pages/Home';
import Support from './pages/Support';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Term from './pages/Term';
import AppWaitlist from './pages/AppWaitlist';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/support" element={<Support />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/term" element={<Term />} />
          <Route path="/:appId" element={<AppWaitlist />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;
